import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * DefaultUrlSerializer reads `(...)` in a path as auxiliary-outlet syntax, so a
 * URL such as `/case-study(1)` parses as a primary `case-study` plus an unnamed
 * outlet group containing `1`. admin-ui defines no named outlets, so no route
 * can ever match that group and initial navigation throws `NG04002: '1'` instead
 * of reaching the `**` not-found route (SLAPFIVE-FRONTEND-A5Z / #16969).
 *
 * Parentheses in the path are percent-encoded before parsing so they are read
 * as part of the segment. Query string and fragment are left untouched.
 */
@Injectable()
export class LiteralParenthesesUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    return super.parse(encodePathParentheses(url));
  }
}

export function encodePathParentheses(url: string): string {
  const pathEnd = url.search(/[?#]/);
  const path = pathEnd === -1 ? url : url.slice(0, pathEnd);
  const rest = pathEnd === -1 ? '' : url.slice(pathEnd);
  return path.replace(/\(/g, '%28').replace(/\)/g, '%29') + rest;
}
